import AfterDoc from '@/components/ui/AfterDoc';
import { CONSULTANTS } from '@/features/v2/consultants';

import { useLingui } from '@lingui/react';

const ThankYouContactCostEstimate = () => {
  const { i18n } = useLingui();

  return (
    <AfterDoc
      consultant={CONSULTANTS.EWELINA_ASSISTANT}
      thankYouMessage={i18n.t(
        'Zgłoś szkodę do ubezpieczyciela i prześlij kosztorys'
      )}
      withButton
    >
      <span>
        {i18n.t(
          'Potrzebujemy kosztorysu naprawy pojazdu aby szybko i skutecznie rozpatrzyć Twoją sprawę. To kluczowy dokument na etapie weryfikacji szkody, a jego analiza pozwoli nam podjąć odpowiednie kroki.'
        )}
      </span>
      <span>
        {i18n.t(
          'Zachowaj szczególną czujność na telefoniczną próbę zawarcia ugody ze strony pracownika ubezpieczalni. Ugoda uniemożliwi Ci otrzymanie dopłaty do odszkodowania. Nasz zespół rzeczoznawców służy pomocą i wsparciem w zakresie wyegzekwowania i wypłaty sprawiedliwej kwoty odszkodowania.'
        )}
      </span>
      <span className="font-semibold">
        {i18n.t('W przypadku pytań zapraszamy do kontaktu.')}
      </span>
    </AfterDoc>
  );
};

export default ThankYouContactCostEstimate;
